import AdditionalMaterial from "@/models/AdditionalMaterial";
import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";
import { materialsApi } from "@/api/interventionClient";

const AdditionalMaterialRepo = useRepo(AdditionalMaterial);

export const useAdditionalMaterialStore = defineStore("additionalMaterial", {
  state: () => ({}),

  actions: {
    async fetchAdditionalsMaterialByPreparation(preparationUuid) {
      const response = await materialsApi.list({
        preparation: preparationUuid,
      });
      AdditionalMaterialRepo.insert(response.results);
      return response;
    },

    async updateAdditionalMaterial(materialData) {
      const { uuid, ...materialRequest } = materialData;
      const additionalMaterial = await materialsApi.update({
        uuid,
        materialRequest,
      });
      AdditionalMaterialRepo.insert(additionalMaterial);
      return additionalMaterial;
    },

    async createAdditionalMaterial(materialData) {
      const additionalMaterial = await materialsApi.create({
        materialRequest: materialData,
      });
      AdditionalMaterialRepo.insert(additionalMaterial);
      return additionalMaterial;
    },

    async destroyAdditionalMaterial(materialUuid) {
      await materialsApi.destroy({ uuid: materialUuid });
      AdditionalMaterialRepo.destroy(materialUuid);
    },
  },

  getters: {},
});
